export default __webpack_public_path__ + "images/8565cf10408666497849ecf997a84f9a-bekker.png";